import { render, staticRenderFns } from "./platform_notice_detail.vue?vue&type=template&id=500a4778&scoped=true"
import script from "./platform_notice_detail.vue?vue&type=script&lang=js"
export * from "./platform_notice_detail.vue?vue&type=script&lang=js"
import style0 from "./platform_notice_detail.vue?vue&type=style&index=0&id=500a4778&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500a4778",
  null
  
)

export default component.exports